// src/components/Navbar.js
import React, { useEffect, useState } from "react";
import "../styles/Navbar.css";

export default function Navbar({ lang, setLang }) {
  const [isOpen, setIsOpen] = useState(false);
  const [hash, setHash] = useState(window.location.hash || "#home");

  useEffect(() => {
    const onHash = () => setHash(window.location.hash || "#home");
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  const NavLink = ({ href, children }) => (
    <a
      href={href}
      onClick={() => setIsOpen(false)}
      className={hash === href ? "active" : undefined}
    >
      {children}
    </a>
  );

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className={`nav-links ${isOpen ? "active" : ""}`}>
          <NavLink href="#home">{lang === "ar" ? "الرئيسية" : "Home"}</NavLink>
          <NavLink href="#floors">{lang === "ar" ? "المخططات" : "Floor Plans"}</NavLink>
          <NavLink href="#gallery">{lang === "ar" ? "المعرض" : "Gallery"}</NavLink>
          <NavLink href="#location">{lang === "ar" ? "الموقع" : "Location"}</NavLink>
          <NavLink href="#about">{lang === "ar" ? "حول" : "About"}</NavLink>
          <NavLink href="#contact">{lang === "ar" ? "اتصل" : "Contact"}</NavLink>
          <button
            onClick={() => setLang(lang === "ar" ? "en" : "ar")}
            style={{
              background: "transparent",
              border: "1px solid white",
              padding: "4px 8px",
              color: "white",
              borderRadius: "6px",
              cursor: "pointer",
              marginLeft: "10px",
            }}
          >
            {lang === "ar" ? "EN" : "AR"}
          </button>
        </div>

        <button
          className={`hamburger ${isOpen ? "open" : ""}`}
          onClick={() => setIsOpen((v) => !v)}
          aria-label="Menu"
          aria-expanded={isOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
}
